import React from 'react'
import { createRoot } from 'react-dom/client'
import { ChangeLogTable, createLoader } from './components/ChangeLogTables'

// Mount point: <div id="…" data-url="…"> holding #changeLogsHistoryTable and #changeLogsAllTable, one per tab panel
export const startChangeLogTables = elementId => {
  const element = document.getElementById(elementId)
  const loader = createLoader(element.dataset.url)
  createRoot(element.querySelector('#changeLogsHistoryTable')).render(
    <ChangeLogTable loader={loader} kind="history" />
  )
  createRoot(element.querySelector('#changeLogsAllTable')).render(
    <ChangeLogTable loader={loader} kind="all" />
  )
}
